<app-no-content *ngIf="!hasPermission"
                [compact]="true"
                title="Access to this content is not allowed"
                i18n-title="Permission Check|Access denied title@@permission-check-access-denied-title"
                details="If you think that this is mistake, please contact support."
                i18n-details="Permission Check|Access denied details@@permission-check-access-denied-details">
  <br/>
</app-no-content>
<ng-content *ngIf="hasPermission"></ng-content>
